<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" lg="3" v-for="(colors, name) in palettes" :key="name">
        <PaletteCard
          @edit="editPalette"
          @select="selectPalette"
          :active="name == activePalette"
          :name="name"
          :colors="colors"
        ></PaletteCard>
      </v-col>
      <v-col cols="6" lg="3">
        <v-btn
          size="x-large"
          color="primary"
          @click="
            dialogEdit = false;
            dialogOpen = true;
          "
          >Create Palette</v-btn
        ></v-col
      >
    </v-row>
    <PaletteDialog
      v-if="dialogOpen"
      :propColors="dialogColors"
      :propName="dialogName"
      :editing="dialogEdit"
      @cancel="dialogOpen = false"
      @submit="createPalette"
      @delete="deletePalette"
    />
  </v-container>
</template>
<script>
const convertToRGB = function (hexString) {
  if (hexString.length != 7) {
    throw "Only six-digit hex colors are allowed.";
  }

  hexString = hexString.substring(1);
  var aRgbHex = hexString.match(/.{1,2}/g);
  var aRgb = [
    parseInt(aRgbHex[0], 16),
    parseInt(aRgbHex[1], 16),
    parseInt(aRgbHex[2], 16),
  ];

  return aRgb;
};

const api = {
  insert(name, colors) {
    const paletteObj = {
      title: name,
      data: colors,
    };
    fetch(
      "https://colinbrown.api.stdlib.com/sheets-led@1.0.0/palette/insert/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paletteObj),
      }
    );
  },
  fetch(vm) {
    console.log("Requesting Palettes");
    fetch("https://colinbrown.api.stdlib.com/sheets-led@1.0.0/palette/fetch/")
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const intermediate = data.map((row) => {
          return [row.title, row.data];
        });
        vm.palettes = Object.fromEntries(intermediate);
        console.log("Palettes Recieved");
      })
      .catch(function (err) {
        console.log(err);
      });
  },
  update(name, colors) {
    const paletteObj = {
      title: name,
      data: colors,
    };
    fetch(
      "https://colinbrown.api.stdlib.com/sheets-led@1.0.0/palette/update/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paletteObj),
      }
    );
  },
  delete(name) {
    fetch(
      "https://colinbrown.api.stdlib.com/sheets-led@1.0.0/palette/delete/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: `{"title" : ` + `"` + name + `"}`,
      }
    );
  },
};

import PaletteCard from "./PaletteCard.vue";
import PaletteDialog from "./PaletteDialog.vue";

export default {
  props: {
    BLE: Object,
  },
  components: {
    PaletteCard,
    PaletteDialog,
  },
  created() {
    api.fetch(this);
  },
  methods: {
    selectPalette(name) {
      this.activePalette = name;
      this.sendPalette(this.palettes[name]);
    },
    editPalette(name) {
      this.dialogEdit = true;
      this.dialogName = name;
      this.dialogColors = this.palettes[name];
      this.dialogOpen = true;
    },
    createPalette(name, colors) {
      this.palettes[name] = colors;
      this.dialogOpen = false;
      if (this.dialogEdit) {
        api.update(name, colors);
      } else {
        api.insert(name, colors);
      }
    },
    deletePalette(name) {
      if (confirm("Delete Palette?")) {
        api.delete(name);
        delete this.palettes[name];
        this.dialogOpen = false;
      }
    },
    sendPalette(palette) {
      var preparedPalette = {};
      preparedPalette.colors = palette.map(convertToRGB);
      preparedPalette.length = preparedPalette.colors.length;
      this.BLE.sendPalette(JSON.stringify(preparedPalette));
    },
  },
  data: () => ({
    activePalette: "",
    palettes: { Loading: ["#000000", "#FFFFFF"] },
    dialogOpen: false,
    dialogEdit: false,
    dialogColors: [],
    dialogName: "",
  }),
};
</script> 
